
  import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
  import lgmMixin from '~/mixins/lgmMixin';

  export default {
    name: "SuggestionCard",
    mixins: [eventTrackingMixins, lgmMixin],

    props: {
        data: {
            type: Object,
            default: () => { },
        },
        indexData: Number,
        persona: String,
        comboId: String,
        isMobile: String
    },
    data() {
        return {
            settings: {
                cardColor: {
                    0: "top-orange",
                    1: "top-red",
                    2: "top-green"
                },
            },
            showTooltips: {},
            clearTooltip: 0
        };
    },

    beforeMount() {
        this.addClearTooltipEventHandler();
    },

    beforeDestroy() {
        this.removeClearTooltipEventHandler();
    },

    methods: {
        getRouteName() {
        return (this.$route.name).substring(0, (this.$route.name).indexOf('___'));
        },
        getEventTrackingLocationName() {
            if (this.getRouteName() === 'index')
                return 'homepage'
            if (this.getRouteName() === 'life-stage')
                return 'lifestage'
            if (this.getRouteName() === 'advisor-service')
                return 'broker'

            return 'other'
        },
        handleEventTracking(client, cardData, extraData){
            event.preventDefault()
            const params = {}
            params.categoryPrefix = `${this.getEventTrackingLocationName()}_`

            const eventTrackingParams = {
                a: `open_${client}`,
                c: params.categoryPrefix + 'cta',
                l: '',
                cd:{
                "login_status":'NA',
                "lifestage_persona": this.persona,
                "lifestage_budget_level": cardData?.Title,
                "lifestage_product_category": ''
                },
                save_action_entrypoint_with_label: false ,
                fbq: {
                    content_name: extraData?.fbq_content_name ?? ''
                }
            }
            this.sendEventTracking(eventTrackingParams)

            this.$goToURL(cardData?.CTALink, false, eventTrackingParams, {
                getLGMConversionId: this.getLGMConversionId,
                injectLGMConversionId: this.injectLGMConversionId,
                injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
            });
        },

        addClearTooltipEventHandler() {
            window.addEventListener(
                'scroll',
                this.$_.debounce(this.handleClearTooltip, 150)
            );
        },
        removeClearTooltipEventHandler() {
            window.removeEventListener('scroll', this.handleClearTooltip);
        },
        handleClearTooltip() {
            this.showTooltips = {}
            this.clearTooltip ++
        },

        enableTooltip(id) {
            this.$set(this.showTooltips, id, true)
        },

    }
}
